import moment from 'moment';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Col, Row, Tooltip, Popover, Upload, message, Spin, notification } from 'antd';
import { debounce, ceil, isEmpty, trim, sortBy as sort,indexOf, isArray } from 'lodash';
import { AiOutlineDelete } from 'react-icons/ai';

import SearchInput from '../../components/uiComponent/inputs/searchinput/index';
import Button from '../../components/uiComponent/button/index';
import AgGrid from '../../components/ag-grid-table/index';
import Pagination from '../../components/pagination/index';
import Modal from '../../components/uiComponent/modal/index';
import * as Switch from '@radix-ui/react-switch';
import Input from '../../components/uiComponent/inputs/input/index';
import ProductRowDetails from './productRowDetails';
import MapSkuModal from './MapSkuModal';
import BulkProductSkuUpload from './BulkProductSkuUpload';
import ReactSelect from '../../components/uiComponent/select';
import XLSX from 'xlsx';

import ProductImg from '../../assets/images/newImages/nestle.svg';
import copyIcon from '../../assets/images/newImages/copy-white-icon.svg';
import copyIcona from '../../assets/images/newImages/copyIcona.svg';
import EditIcon from '../../assets/images/edit-icon.svg';
import InfoIcon from '../../assets/images/newImages/info-icon-blue.svg';
import WarningInfoIcon from '../../assets/images/newImages/info-icon.svg';
import PoBreakdownIcon from '../restock/PoBreakdownIcon.jsx';
import ReservedStockCell from '../../components/UI/ReservedStockCell.jsx';
import uploadIcon from '../../assets/images/newImages/upload-icon.svg';
import importIcon from '../../assets/images/newImages/import-xlsx.svg';
import FileIcon from '../../assets/icons/file-icon.svg';
import { IoIosArrowDown } from 'react-icons/io';

import InventoryWrapper from './style';

import { AddProduct, GetProducts, EditProduct, ExportFilteredProducts, GetUnitCostHistories } from '../../slices/3-layer-products';
import { GetVendorsList } from '../../slices/po';
import { VALID_UPC_REGEX, VALID_IMAGE_URL_REGEX } from '../../constants/threeLayer';
import { useSelector, useDispatch } from 'react-redux';

import { GetPresignedUrl, StoreProductsFile } from '../../slices/aws-services';
import { setItem } from '../../slices/auth';
import { copyToClip } from '../../utils/utils';
import { GoUpload } from 'react-icons/go';
import MappingAlert from './mappingAlert';

const { Dragger } = Upload;

const defaultColDef = {
  resizable: true,
  sortable: false,
  suppressMenu: true,
  suppressMovable: true,
  suppressSorting: true
};

const initialProductData = {
  name: '',
  description: '',
  imageUrl: '',
  brand: '',
  identifierType: '',
  identifierValue: ''

};

const identifierOption = [
  { value: 'UPC', label: 'UPC' },
  { value: 'EAN', label: 'EAN' },
  { value: 'ISBN', label: 'ISBN' },
  { value: 'GTIN', label: 'GTIN' }
];

let gridApi;
let gridColumnApi;

const CogsCellRenderer = (params) => {
  const { value, data, context } = params;
  const num = Number(value || 0);
  const formattedValue = Number.isInteger(num) ? num.toString() : num.toFixed(2);

  return (
    <div className='d-flex align-items-center gap-1'>
      <span>{formattedValue}</span>
      <img
        src={InfoIcon}
        alt='info'
        className='cursor-pointer'
        width={14}
        height={14}
        onClick={() => context?.handleShowCogsDetail(data.id)}
      />
    </div>
  );
};


const Products = () => {
  const dispatch = useDispatch();
  const searchRef = useRef(null);

  const [showProductModal, setShowProductModal] = useState({ status: false, isEdit: false });
  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });
  const [filters, setFilters] = useState({ search: '', vendorId: null });
  const [sortBy, setSortBy] = useState({ key: '', type: '' });

  // Always-current mirrors of the list state. ag-grid captures the detail-row renderer ONCE at
  // grid init, so callbacks reached from inside it close over the FIRST render's page/filters/
  // sortBy — refetching with those stale values silently drops the user's applied sort.
  const pageStateRef = useRef(page);
  const filtersStateRef = useRef(filters);
  const sortByStateRef = useRef(sortBy);
  pageStateRef.current = page;
  filtersStateRef.current = filters;
  sortByStateRef.current = sortBy;
  const [product, setProduct] = useState(initialProductData);
  const [mapSkuModal, setMapSkuModal] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [uploadFile, setUploadFile] = useState({});
  const [fileUploadingLoading, setFileUploadingLoading] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [rowIndex, setRowIndex] = useState(-1);
  const [showMappingAlert, setShowMappingAlert] = useState(false);
  const [cogsDetailModal, setCogsDetailModal] = useState({ status: false, productId: null });
  const [showOutOfStock, setShowOutOfStock] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);


  const {
    unlinkVendorItemLoading
  } = useSelector(state => state.vendorItems);

  const { vendorsList, fetchingVendorsList } = useSelector(state => state.pos);

  useEffect(() => {
    dispatch(GetVendorsList());
  }, []);

  const handleVisibleChange = (visible) => {
    setPopoverVisible(visible);
  };
  const handleExportAll =  ()=>{
    dispatch(GetProducts({exportAll : true})).then(({payload})=>{
      if(payload.success == true){
        handleExportProducts(payload.result);
      }
    });
  };
  const handleExportFiltered = () => {
    const isFilterApplied = Object.entries(filters).some(([key, value]) => {
      if (key === 'vendorId') return value !== null;
      return value !== '';
    });

    if (!isFilterApplied) {
      notification.error({
        top: 65,
        message: 'Export Filtered',
        description: 'Please Select a Filter First'
      });
      return;
    }

    dispatch(ExportFilteredProducts({ filters, sortBy })).then(({ payload }) => {
      if (payload.success == true) {
        handleExportProducts(payload.result);
      }
    });
  };
  const handleExportProducts = (data)=>{
    setOpenExport(false);

    let sortedSelectedRows;

    if (isArray(data)) {
        sortedSelectedRows = data; // Use data directly if it's an array
    } else {
        const selectedRows = selectedItems;
    
        if (selectedRows.length === 0) {
            notification.error({
                top: 65,
                message: 'Export SKU(s)',
                description: 'Please select at least one row to export.'
            });
            return;
        }
    
        sortedSelectedRows = sort(selectedRows, (item) => indexOf(products, item));
    }
    
    const mappedData = sortedSelectedRows?.map((product) => {
      const {
      name,
      brand,
      identifier_type,
      identifier_value,
      warehouse_stock,
      inbound_stock,
      pending_on_po,
      fba_stock,
      reserved_stock,
      total_stock,
      image_url,
      product_value,
      cogs = '-',
      adjusted_sales_velocity = '-'
      } = product || {};
  
      return {
      'Product Name': name || 'N/A',
      'Image Url' : image_url || 'N/A',
      'Brand': brand || 'N/A',
      'Cogs': cogs,
      'Adjusted Sales Velocity(90 Days)': adjusted_sales_velocity,
      'Identifier Type': identifier_type?.toUpperCase() || 'N/A',
      'Identifier Value': identifier_value || 'N/A',
      'Warehouse Stock': warehouse_stock || 0,
      'Inbound Stock': inbound_stock || 0,
      'Pending on PO': pending_on_po || 0,
      'FBA Stock': fba_stock || 0,
      'Reserved Stock': reserved_stock || 0,
      'Total Stock': total_stock || 0,
      'Inventory Value': product_value != null && !isNaN(product_value) ? `$${Number(product_value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '$0.00'
      };
    });
  
    const worksheet = XLSX.utils.json_to_sheet(mappedData);
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Products');
  
    XLSX.writeFile(workbook, 'Product.xlsx');
  };

  const uploadProps = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    accept: ['.xlsx', '.xls', '.csv'],
    fileList: !isEmpty(uploadFile) ? [{ ...uploadFile, name: uploadFile.name, key: uploadFile.uid || uploadFile.name }] : [],
    onChange(info) {
      if (info.fileList.length === 0) {
        return;
      }
      const file = info.file;
      const fileExtension = file?.name?.split('.').pop();
      if (!['xls', 'xlsx', 'csv'].includes(fileExtension)) {
        message.error(`${file.name} upload failed. Only Excel and Csv files are allowed.`);
        return;
      }
      setUploadFile(file);
    },
    beforeUpload: () => false,
    onRemove: () => {
      setUploadFile({});
      return true;
    }
  };

  const handleFileUpload = async () => {
    let uploadedFile = {};
    if (!isEmpty(uploadFile)) {
      setFileUploadingLoading(true);
      dispatch(setItem({
        field: 'showFileHeader',
        value: false
      }));
      await dispatch(GetPresignedUrl({ files: [uploadFile] })).then(({ payload }) => {
        if (!payload?.error) {
          uploadedFile = payload[0];
        }
      });
      if (uploadedFile) {
        await dispatch(StoreProductsFile({ fileName: uploadedFile?.key, fileUrl: uploadedFile?.url, fileType: uploadedFile?.extension, type: 'products' })).then(({ payload }) => {
          if (!payload?.error) {
            message.success('File Uploaded Successfully');
          } else {
            message.error('Error While Uploading File');
          }
          setFileUploadingLoading(false);
          setUploadFile({});
          setPopoverVisible(false);
        });
      }
      await dispatch(GetProducts({ page, filters, sortBy }));
      dispatch(setItem({
        field: 'showFileHeader',
        value: true
      }));
    }
  };

  const content = (
    <InventoryWrapper style={{ width: 350 }} className='pt-0'>
      <p className="text-primary d-flex align-items-center gap-1">
        <a
          href="https://opulant-storage.s3.us-east-1.amazonaws.com/products-template-file.xlsx"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary d-flex align-items-center gap-1"
        >
          <img src={InfoIcon} alt="info" />
          <span className="fs-12 fw-semibold">Download Sample File</span>
        </a>      </p>
      <Dragger maxCount={1} {...uploadProps} style={{ marginTop: 16, padding: 16, borderRadius: 8 }}>
        <p className="ant-upload-drag-icon">
          <img src={uploadIcon} alt='upload' />
        </p>
        <p className="ant-upload-text text-primary fs-14 fw-semibold text-decoration-underline">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single upload
        </p>
      </Dragger>

      <p className="text-grey d-flex align-items-center gap-1 mt-2">
        <img src={WarningInfoIcon} alt="warning" />
        <span className="fs-12 fw-semibold">Products with Incomplete data will not be Added</span>
      </p>

      <h6>Uploaded Files</h6>
      {
        !isEmpty(uploadFile) &&
        <div className="uploaded-file-container">
          <div key={uploadFile.uid} className="uploading-content-data">
            <div className="title">
              <img src={FileIcon} alt="File Icon" title="File Icon" />
              <span>{uploadFile.name}</span>
            </div>
            <AiOutlineDelete onClick={() => setUploadFile({})} style={{ cursor: 'pointer', color: 'red' }} />
          </div>
        </div>
      }
      <div className='d-flex gap-2 justify-content-end mt-3'>
        <Button
          text="Cancel"
          className="outlined mb-0"
          onClick={() => {
            setPopoverVisible(false);
            setUploadFile({});
          }
          }
        />
        <Button
          text={fileUploadingLoading ? 'Uploading..' : 'Save'}
          disabled={fileUploadingLoading || isEmpty(uploadFile)}
          className="primary mb-0"
          onClick={handleFileUpload}
        />
      </div>
    </InventoryWrapper>
  );

  const {
    products,
    fetchingProducts,
    totalProductsCount,
    addingProduct,
    unLinkingItem,
    editingProduct,
    exportingData,
    mappingAlertData,
    mappingAlertErrorMsg,
    checkingWorkOrderLinkStatus,
    unitCostHistories,
    fetchingUnitCostHistories
  } = useSelector((state) => state.threeLayerProducts || {});

  useEffect(() => {
    if (gridApi && products?.length > 0) {
      gridApi.forEachNode((node) => {
        if (selectedItems.some(i => i.id === node.data.id)) {
          node.setSelected(true, false, true);
        }
      });
    }
  }, [products, gridApi]);


  useEffect(() => {
    if (cogsDetailModal.status && cogsDetailModal.productId) {
      dispatch(GetUnitCostHistories({ productId: cogsDetailModal.productId }));
    }
  }, [cogsDetailModal.status, cogsDetailModal.productId]);


  useEffect(() => {
    dispatch(GetProducts({ page, filters, sortBy }));
  }, []);

  // Refetch in place and re-expand the row. Every caller (unlink SKU / unlink vendor item / map
  // SKU / detail-row modals) is an IN-PLACE change to an existing product, so the user's page,
  // filters and applied sorting must survive — the old version reset all three, which wiped the
  // sort after unlinking. Reads the refs because these callers live inside ag-grid's detail
  // renderer, whose closure is frozen at grid init.
  const expandRow = async (rowId) => {
    dispatch(GetProducts({
      page: pageStateRef.current,
      filters: filtersStateRef.current,
      sortBy: sortByStateRef.current
    })).then(() => {
      if (gridApi) {
        gridApi.forEachNode((node) => {
          if (node.data.id === rowId) {
            node.setExpanded(true);
          }
        });
      }
    });
  };

  const gridReady = (params) => {
    gridApi = params.api;
    gridColumnApi = params.columnApi;
  };

  const onSelectionChange = () => {
    const currentPageSelected = gridApi?.getSelectedRows?.() || [];
    const currentPageAll = products || [];
    const currentPageAllIds = currentPageAll.map(i => i.id);

    setSelectedItems(prev => {
      const otherPagesSelected = prev.filter(i => !currentPageAllIds.includes(i.id));
      const newSelected = [...otherPagesSelected, ...currentPageSelected];
      setSelectedRowsCount(newSelected.length);
      return newSelected;
    });
  };

  const columnDefs = useMemo(() => [
    {
      headerName: '',
      width: 75,
      // field: 'seller_skus.length',
      valueGetter: (params) => params.data?.seller_skus?.length || 0, // Safely access nested property
      cellRenderer: 'agGroupCellRenderer'
    },
    {
      headerCheckboxSelection: true,
      width: 35,
      checkboxSelection: true,
      field: 'select'
    },
    {
      headerName: 'Product',
      filter: true,
      minWidth: 380,
      flex: 1,
      cellRenderer: ({ data }) => {
        const { name, image_url, identifier_value, identifier_type } = data || {};
        return (
          <div className="product-title">
            <img src={image_url || ProductImg} alt="product" width={28} height={28} className='product-img' />
            <div className='w-100'>
              <Tooltip placement="bottom" title={name}>
                <span className="product-name">{name}</span>
              </Tooltip>
              <div className='asin'>
                <span>{identifier_type?.toUpperCase()} - {identifier_value}</span>
                <img src={copyIcon} alt='copy' className='cursor-pointer'
                  onClick={() => copyToClip(identifier_value)} />
              </div>
            </div>
          </div>
        );
      }
    },
    {
      headerName: 'Brand',
      field: 'brand',
      minWidth: 90,
      flex: 1,
      cellRenderer: ({ value }) => {
        if (value) {
          return (
            <div
              className='fnsku'
              style={{
                background: '#E1EDFF',
                color: '#406191',
                display: 'inline-flex',
                width: 'fit-content',
                maxWidth: '100%'
              }}
            >
              <Tooltip placement="top" title={value}>
                <span
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'block',
                    maxWidth: '220px'
                  }}
                >
                  {value}
                </span>
              </Tooltip>
              <img src={copyIcona} alt='copy' className='cursor-pointer'
                style={{ flexShrink: 0 }}
                onClick={() => copyToClip(value)} />
            </div>
          );
        }

        return 'N/A';
      }
    },
    {
      headerName: 'COGS',
      minWidth: 100,
      flex: 1,
      field: 'cogs',
      comparator: () => 0,
      sortable: true,
      cellRenderer: CogsCellRenderer
    },
    {
      headerName: 'ASV (90D)',
      minWidth: 200,
      flex: 1,
      field: 'adjusted_sales_velocity',
      comparator: () => 0,
      sortable: true,
      cellRenderer: ({ value }) => {
        if (value == null || value === '' || value === 0 || value === '0.00') return '-';
        const num = Number(value);
        return Number.isInteger(num) ? num.toString() : num.toFixed(2);
      }
    },
    {
      headerName: 'WH Stock',
      minWidth: 100,
      flex: 1,
      field: 'warehouse_stock',
      comparator: () => 0,
      sortable: true,
      cellRenderer: ({ value }) => value || 0
    },
      {
      headerName: 'Pending on PO',
      minWidth: 140,
      flex: 1,
      field: 'pending_on_po',
      comparator: () => 0,
      sortable: true,
      cellRenderer: ({ value, data }) => (
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          {value || 0}
          {Number(value) > 0 && data?.identifier_value
            && <PoBreakdownIcon params={{ upc: data.identifier_value }} label={data.identifier_value} type="pending" />}
        </span>
      )
    },
    // {
    //   headerName: 'WH Reserved Stock',
    //   minWidth: 130,
    //   flex: 1,
    //   field: 'reserved_qty',
    //   comparator: () => 0,
    //   sortable: true,
    //   cellRenderer: ({ value }) => value || 0
    // },
    {
      headerName: 'Inbound',
      minWidth: 80,
      flex: 1,
      field: 'inbound_stock',
      comparator: () => 0,
      sortable: true,
      cellRenderer: ({ value, data }) => (
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          {value || 0}
          {Number(value) > 0 && data?.identifier_value
            && <PoBreakdownIcon params={{ upc: data.identifier_value }} label={data.identifier_value} type="inbound" />}
        </span>
      )
    },
  
    {
      headerName: 'FBA Stock',
      minWidth: 80,
      flex: 1,
      field: 'fba_stock',
      comparator: () => 0,
      sortable: true,
      cellRenderer: ({ value }) => value || 0
    },
    {
      // Allocated to an Amazon shipment but not fulfillable yet — Pack Now units pulled from WH
      // stock pre-placement, plus Amazon's own inboundWorkingQuantity (kept out of FBA Stock to
      // avoid double-counting). Hover the info icon for the breakdown.
      headerName: 'Reserved Stock',
      minWidth: 130,
      flex: 1,
      field: 'reserved_stock',
      comparator: () => 0,
      sortable: true,
      cellRenderer: ({ value, data }) => (
        <ReservedStockCell
          value={value}
          internal={data?.reserved_internal}
          amazonInboundWorking={data?.reserved_amazon_inbound_working}
        />
      )
    },
    {
      headerName: 'Total Stock',
      minWidth: 80,
      flex: 1,
      field: 'total_stock',
      comparator: () => 0,
      sortable: true,
      cellRenderer: ({ value }) => value || 0
    },
    {
      headerName: 'Inventory Value',
      minWidth: 80,
      flex: 1,
      field: 'product_value',
      sortable: true,
      cellRenderer: ({ value }) => {
        if (value == null || value === '' || isNaN(value)) return '$0.00';
        return `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      }
    },
    {
      headerName: 'Action',
      minWidth: 76,
      maxWidth: 76,
      flex: 1,
      headerClass: 'ag-center-aligned-header',
      headerStyle: { textAlign: 'center' },
      cellRenderer: ({ data }) => {
        const {
          name,
          description,
          image_url: imageUrl,
          identifier_value,
          identifier_type,
          brand
        } = data || {};

        return (
          <div className='d-flex align-items-center justify-content-center gap-2'>
            <img src={EditIcon} alt='edit' className='cursor-pointer'
              onClick={() => {
                setProduct({
                  name,
                  description,
                  imageUrl,
                  brand,
                  identifierType: identifier_type || 'EAN',
                  identifierValue: identifier_value || ''
                });
                setShowProductModal({ status: true, isEdit: true });
              }}
            />
          </div>
        );
      }
    }
  ], []);

  const cogsDetailColumnDefs = useMemo(() => [
    {
      headerName: 'PO Name',
      field: 'po_name',
      minWidth: 200,
      flex: 1,
      cellRenderer: ({ value }) => value || 'N/A'
    },
    {
      headerName: 'Created At',
      field: 'created_at',
      minWidth: 120,
      flex: 1,
      cellRenderer: ({ value }) => value ? moment(value).format('MM/DD/YYYY') : 'N/A'
    },
    {
      headerName: 'Received',
      field: 'received_quantity',
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ value }) => value ?? 0
    },
    {
      headerName: 'Adjustment',
      field: 'adj_received_quantity',
      minWidth: 120,
      flex: 1,
      cellRenderer: ({ value, data }) => {
        const num = Number(value || 0);
        const displayVal = num === 0 ? '0' : num > 0 ? `+${num}` : `${num}`;
        const history = data?.adjustment_history || [];
        if (!history.length) return <span>{displayVal}</span>;
        const content = (
          <div style={{ maxHeight: '220px', overflowY: 'auto', minWidth: '300px', paddingRight: '12px' }}>
            {history
              .slice()
              .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
              .map((adj, i) => (
              <div key={i} style={{ padding: '5px 0', borderBottom: i < history.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontWeight: 500, fontSize: '12px' }}>{adj.adjustment_category || (adj.event_type ? adj.event_type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : 'Adjustment')}</span>
                  <span style={{ fontWeight: 600, fontSize: '12px', color: adj.quantity_changed > 0 ? '#52c41a' : '#ff4d4f', whiteSpace: 'nowrap' }}>
                    {adj.quantity_changed > 0 ? `+${adj.quantity_changed}` : adj.quantity_changed}
                  </span>
                </div>
                <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>
                  {moment(adj.created_at).format('MM/DD/YYYY')} · {adj.user_name || (adj.initiated_by === 'amazon_ledger' ? 'Ledger Report' : 'System')}
                </div>
                {adj.notes && <div style={{ fontSize: '11px', color: '#aaa', fontStyle: 'italic', marginTop: '2px' }}>{adj.notes}</div>}
              </div>
            ))}
          </div>
        );
        return (
          <Popover content={content} title="Adjustment History" trigger="hover" placement="left">
            <span style={{ cursor: 'default', borderBottom: '1px dotted currentColor' }}>{displayVal}</span>
          </Popover>
        );
      }
    },
    {
      headerName: 'Used',
      field: 'used_quantity',
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ value }) => value ?? 0
    },
    {
      headerName: 'Available',
      field: 'inbound_stock',
      minWidth: 150,
      flex: 1,
      cellRenderer: ({ value }) => value ?? 0
    },
    {
      headerName: 'Unit Cost',
      field: 'unit_cost',
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ value }) => `$${Number(value).toFixed(2)}`
    }
  ], []);

  const processedUnitCostHistories = useMemo(() => {
    if (!unitCostHistories?.length) return [];
    return unitCostHistories
      .filter((item) => showOutOfStock || Number(item.inbound_stock || 0) > 0)
      .map((item) => ({
        ...item,
        po_name: item.is_mapping_entry 
          ? (Number(item.inbound_stock || 0) === 0 ? 'Sku Unmapping' : 'Sku Mapping')
          : item.po_name
      }));
  }, [unitCostHistories, showOutOfStock]);

  const cogsCalculationSummary = useMemo(() => {
    if (!processedUnitCostHistories?.length) return null;
    let totalValue = 0;
    let totalAvailable = 0;
    
    processedUnitCostHistories.forEach(h => {
      const avail = Number(h.inbound_stock || 0);
      const cost = Number(h.unit_cost || 0);
      if (avail > 0) {
        totalValue += (avail * cost);
        totalAvailable += avail;
      }
    });

    const weightedAvg = totalAvailable > 0 ? (totalValue / totalAvailable) : 0;
    return {
      totalValue,
      totalAvailable,
      weightedAvg
    };
  }, [processedUnitCostHistories]);

  const handleShowCogsDetail = (id) => {
    dispatch(GetUnitCostHistories({ productId: id })).then(() => {
      setCogsDetailModal({ status: true, productId: id });
    });
  };

  const handleSearchProduct = debounce((value) => {
    setFilters((prev) => {
      if (trim(value) || prev.search) {
        setPage(page => ({ ...page, pageNumber: 1 }));
        dispatch(GetProducts({
          page: { ...page, pageNumber: 1 },
          filters: { ...prev, search: trim(value) },
          sortBy
        }));
      }
      return { ...prev, search: value };
    });
  }, 800);

  const handlePagination = (number, key) => {
    const value = Number(number);
    let newPage = {};

    if (key === 'pageSize') newPage = { pageNumber: 1, pageSize: value };
    else newPage = { ...page, pageNumber: value };

    setPage(newPage);
    dispatch(GetProducts({
      page: newPage,
      filters,
      sortBy
    }));
  };

  const refreshGridClick = () => {
    if (gridColumnApi){
      gridColumnApi.applyColumnState({
        defaultState: { sort: null },
        applyOrder: true
      });
      setSortBy({ key: '', type: '' });
    }

    dispatch(GetProducts({
      page,
      filters
    }));
  };

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null);

    if (value && ['avg_price', 'available_stock', 'total_value', 'warehouse_stock', 'reserved_qty', 'inbound_stock', 'pending_on_po', 'fba_stock', 'reserved_stock', 'total_stock', 'cogs', 'product_value', 'adjusted_sales_velocity'].includes(value?.colId)) {
      const { colId, sort } = value || {};
      setSortBy({ key: colId, type: sort });
      dispatch(GetProducts({
        page,
        filters,
        sortBy: { key: colId, type: sort }
      }));
    }
  };

  const addProductDisableStatus = () => {
    const { identifierType, name, identifierValue, brand } = product || {};
    if (!name) return true;
    if (!identifierType) return true;
    if (!brand) return true;
    if (!identifierValue) return true;
    if (identifierType?.toLowerCase() === 'upc' && identifierValue?.toString()?.length !== 12) return true;
    if (identifierType?.toLowerCase() === 'isbn' && (identifierValue?.toString()?.length !== 10
      && identifierValue?.toString()?.length !== 13)) return true;
    if (identifierType?.toLowerCase() === 'ean' && identifierValue?.toString()?.length !== 13) return true;
    if (identifierType?.toLowerCase() === 'gtin' && identifierValue?.toString()?.length !== 14) return true;
  };

  const { pageNumber, pageSize } = page || {};

  const handleRefreshPageData = ({ preserve = false } = {}) => {
    // In-place changes (edit product, detail-row actions) only alter row DATA — keep the user's
    // page, filters and applied sorting and just refetch (via the refs: this can be reached
    // through ag-grid's detail renderer, whose closure is frozen at grid init).
    if (preserve) {
      dispatch(GetProducts({
        page: pageStateRef.current,
        filters: filtersStateRef.current,
        sortBy: sortByStateRef.current
      }));
      return;
    }

    // Full reset (adding a new product): back to page 1 with cleared search/sort so it's visible.
    setPage(page => ({ ...page, pageNumber: 1 }));
    setSortBy({ key: '', type: '' });
    setFilters(prev => {
      const newFilters = { ...prev, search: '' };
      searchRef.current.value = '';
      dispatch(GetProducts({
        page: { ...pageStateRef.current, pageNumber: 1 },
        filters: newFilters,
        sortBy: { key: '', type: '' }
      }));
      return newFilters;
    });
  };

  const handleShowMappingAlert = () => {
    setMapSkuModal(false);
    setShowMappingAlert(true);
  };

  const SelectExportType = ()=>{
    return (
      <InventoryWrapper className='mt-0'>
        <div className='items-menu'>
          <span onClick={() => handleExportProducts()}>Export Selected</span>
          <span onClick={handleExportFiltered}>Export Filtered</span>
          <span onClick={handleExportAll}>Export All</span>
        </div>
      </InventoryWrapper>
    );
  };
  
  const handleExportToggle = (e)=>{
    setOpenExport(!openExport);
    e.stopPropagation();
  };


  return (
    <InventoryWrapper>
      <div className='sku-bar'>
        <SearchInput
          placeholder="Search by Brand / Identifier / Title"
          width="264px"
          inputRef={searchRef}
          onChange={({ target }) => handleSearchProduct(target.value)}
        />
        <div className='sku-inputs'>
          <ReactSelect
            options={vendorsList}
            placeholder="Select Vendor"
            width="200px"
            className="mb-0"
            disabled={fetchingVendorsList}
            value={filters.vendorId ? vendorsList.find(v => v.id === filters.vendorId) : null}
            onChange={(option) => {
              const newVendorId = option?.id || null;
              setFilters(prev => {
                const newFilters = { ...prev, vendorId: newVendorId };
                setPage(page => ({ ...page, pageNumber: 1 }));
                dispatch(GetProducts({
                  page: { ...page, pageNumber: 1 },
                  filters: { ...newFilters, search: trim(searchRef.current?.value || '') },
                  sortBy
                }));
                return newFilters;
              });
            }}
            isClearable={true}
          />
          <Popover visible={openExport} overlayStyle={{ padding: 0 }} overlayClassName='dropdown-pop' trigger='click' Arrow={false} placement='bottom' title={null} content={<SelectExportType />}>
          <Spin size='small' spinning={exportingData}>
          <Button 
          disabled={!products?.length || exportingData}
           onClick={handleExportToggle} startIcon={<GoUpload style={{marginRight:'16px'}}/>} endIcon={<IoIosArrowDown />} className="outlined mb-0" text="Export" />
           </Spin>
          </Popover>
          <Button
            text="Add Product"
            className="outlined mb-0"
            startIcon={<span className="icon-add pr-8"></span>}
            minWidth="96px"
            onClick={() => setShowProductModal({ status: true, isEdit: false })}
          />
          <Popover
            content={content}
            trigger="click"
            placement="bottomRight"
            visible={popoverVisible}
            onVisibleChange={handleVisibleChange}
          >
            <Button
              text="Bulk Create Products"
              className="primary mb-0"
              startIcon={<img src={importIcon} alt='import' />}
              minWidth="90px"
            />
          </Popover>
          <BulkProductSkuUpload onSuccess={() => dispatch(GetProducts({ page, filters: { ...filters, search: trim(searchRef.current?.value || '') }, sortBy }))} />
        </div>
      </div>
      <Spin tip='Loading...' spinning={fetchingProducts || unLinkingItem || unlinkVendorItemLoading || checkingWorkOrderLinkStatus || fetchingUnitCostHistories}>
        <AgGrid
          gridReady={gridReady}
          user_referrals={products}
          defaultColDef={defaultColDef}
          columnDefinitions={columnDefs}
          onSortChange={onSortChange}
          rowHeight={52}
          headerHeight={34}
          height="200px"
          masterDetail={true}
          rowSelection="multiple"
          detailRowAutoHeight={true}
          detailCellRenderer={(props) =>
            <ProductRowDetails {...props}
              handleRefreshPageData={() => handleRefreshPageData({ preserve: true })}
              setShowMappingAlert={setShowMappingAlert}
              expandRow={expandRow}
              openMapSkuModal={(index) => {
                setRowIndex(index);
                setMapSkuModal(true);
              }}
            />
          }
          className="sku-table"
          onSelectionChanged={onSelectionChange}
      
          context={{ handleShowCogsDetail }}
        />
      </Spin>
      <Modal
        open={cogsDetailModal.status}
        onHide={() => setCogsDetailModal({ status: false, productId: null })}
        closeText="Close"
        header={true}
        heading="Cogs BreakDown"
        closeButton={true}
        onClose={() => setCogsDetailModal({ status: false, productId: null })}
        saveButton={false}
        className="cogs-modal-full-width cogs-modal-scroll"
        size="lg"
      >
        <InventoryWrapper className='sku-modal modal-grid cogs-modal-content p-0 d-flex flex-column' style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
          <div className='cogs-header-section d-flex align-items-center justify-content-between pr-3'>
            {products?.find(p => p.id === cogsDetailModal.productId) && (() => {
              const currentProduct = products.find(p => p.id === cogsDetailModal.productId);
              return (
                <div className="product-title modal-product-info mb-0">
                  <img src={currentProduct.image_url || ProductImg} alt="product" className='product-img' />
                  <div className='w-100' style={{ minWidth: 0 }}>
                    <Tooltip placement="bottom" title={currentProduct.name}>
                      <span className="product-name">{currentProduct.name}</span>
                    </Tooltip>
                    <div className='asin' style={{ display: 'inline-flex' }}>
                      <span>{currentProduct.identifier_type?.toUpperCase()} - {currentProduct.identifier_value}</span>
                      <img src={copyIcon} alt='copy' className='cursor-pointer ms-1'
                        onClick={() => copyToClip(currentProduct.identifier_value)}
                      />
                    </div>
                  </div>
                </div>
              );
            })()}
            <div className='d-flex align-items-center gap-2'>
              <span className='fs-12 fw-semibold text-secondary'>Show Out of Stock</span>
              <Switch.Root
                checked={showOutOfStock}
                onCheckedChange={(val) => setShowOutOfStock(val)}
                style={{
                  width: '42px',
                  height: '25px',
                  backgroundColor: showOutOfStock ? '#1565D8' : '#E9ECEF',
                  borderRadius: '9999px',
                  position: 'relative',
                  border: 'none',
                  padding: '0',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
              >
                <Switch.Thumb
                  style={{
                    display: 'block',
                    width: '21px',
                    height: '21px',
                    backgroundColor: 'white',
                    borderRadius: '9999px',
                    boxShadow: '0 2px 4px 0 rgba(0, 35, 11, 0.2)',
                    transform: showOutOfStock ? 'translateX(19px)' : 'translateX(2px)',
                    transition: 'transform 0.2s'
                  }}
                />
              </Switch.Root>
            </div>
          </div>
          
          <div className='flex-grow-1 overflow-auto cogs-body-section cogs-scroll-body' style={{ minHeight: 0 }}>
            <Spin tip='Loading...' spinning={fetchingUnitCostHistories}>
              <AgGrid
                user_referrals={processedUnitCostHistories}
                defaultColDef={defaultColDef}
                columnDefinitions={cogsDetailColumnDefs}
                rowHeight={52}
                headerHeight={34}
                {...(processedUnitCostHistories?.length <= 5 
                  ? { containerHeight: processedUnitCostHistories?.length === 0 ? '120px' : `${(processedUnitCostHistories.length * 52) + 34 + 20}px` } 
                  : { height: '400px' }
                )}
                className="sku-table"
              />
            </Spin>
          </div>
          {cogsCalculationSummary && (
            <div className='cogs-footer-section'>
              <div className='cogs-summary-card'>
                <div className='d-flex align-items-center justify-content-between'>
                  <div>
                    <div className='cogs-summary-label'>Weighted Average COGS</div>
                  
                  </div>
                  <div className='cogs-summary-value'>${cogsCalculationSummary.weightedAvg.toFixed(2)}</div>
                </div>
              </div>
            </div>
          )}
        </InventoryWrapper>
      </Modal>
      <Pagination
        total={totalProductsCount}
        totalPages={ceil(totalProductsCount / pageSize + 1)}
        pageNumber={pageNumber}
        pageLimit={pageSize}
        handleLimitChange={(e) => handlePagination(e, 'pageSize')}
        handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
        refreshGridClick={refreshGridClick}
        isExport={true}
      />
      <Modal
        open={showProductModal.status}
        onHide={() => {
          setShowProductModal({ status: false });
          setProduct(initialProductData);
        }}
        closeText="Cancel"
        saveText={showProductModal.isEdit ? 'Update' : 'Create'}
        header={true}
        closeButton={true}
        onClose={(e) => {
          e.preventDefault();
          setShowProductModal({ status: false });
          setProduct(initialProductData);
        }}
        onSave={() => {
          if (showProductModal.isEdit) {
            dispatch(EditProduct(product)).then(({ payload }) => {
              if (payload?.success) {
                setShowProductModal({ status: false });
                setProduct(initialProductData);
                // Edit = in-place change; keep the user's sort/filters/page.
                handleRefreshPageData({ preserve: true });
              }
            });
          }
          else {
            dispatch(AddProduct(product)).then(({ payload }) => {
              if (payload?.success) {
                setShowProductModal({ status: false });
                setProduct(initialProductData);
                handleRefreshPageData();
              }
            });
          }
        }}
        buttonDisabled={addProductDisableStatus()}
      >
        <InventoryWrapper className='sku-modal'>
          <Spin tip='Loading...' spinning={addingProduct || editingProduct}>
            <h4 className='text-primary fw-bold mb-3'>{showProductModal.isEdit ? 'Edit' : 'Add'} Product</h4>
            <Row gutter={[24, 24]} className='mb-3'>
              <Col span={12}>
                <Input
                  placeholder="Enter"
                  label="Name"
                  important
                  marginBottom="0"
                  value={product.name}
                  onChange={({ target }) => setProduct(product => ({ ...product, name: target?.value }))}
                />
              </Col>
              <Col span={12}>
                <Input
                  placeholder="Enter"
                  label='Description'
                  marginBottom="0"
                  value={product.description}
                  onChange={({ target }) => setProduct(product => ({ ...product, description: target?.value }))}
                />
              </Col>
              <Col span={12}>
                <Input
                  placeholder="Enter"
                  label="Image URL"
                  marginBottom="0"
                  value={product.imageUrl}
                  onChange={({ target }) => setProduct(product => ({ ...product, imageUrl: target?.value }))}
                />
              </Col>
              <Col span={12}>
                <Input
                  placeholder="Enter"
                  label='Brand'
                  important
                  marginBottom="0"
                  value={product.brand}
                  onChange={({ target }) => setProduct(product => ({ ...product, brand: target?.value }))}
                />
              </Col>
              <Col span={12}>
                <ReactSelect
                  options={identifierOption}
                  placeholder="Select"
                  label="Identifier"
                  important
                  style={{ width: '100%' }}
                  disabled={showProductModal.isEdit}
                  value={ showProductModal?.isEdit ? {id: product?.identifierType, label: product?.identifierType, value: product?.identifierType } : product?.identifierType ? identifierOption.find(option => option.value === product.identifierType) : null}
                  onChange={({ value }) => { setProduct((prevProduct) => ({ ...prevProduct, identifierType: value })); }}
                />
              </Col>
              <Col span={12}>
                <Input
                  placeholder="Enter"
                  label="Identifier Value"
                  important
                  type='number'
                  min={1}
                  marginBottom="0"
                  value={product.identifierValue}
                  disabled={showProductModal.isEdit}
                  onChange={({ target }) => {
                    if (/^[0-9]\d*$/.test(target.value) || target.value === '') {
                      setProduct(product => ({ ...product, identifierValue: target.value }));
                    }
                  }
                  }
                />
              </Col>
            </Row>

          </Spin>
        </InventoryWrapper>
      </Modal >
      {showMappingAlert &&
        <MappingAlert
          rowData={mappingAlertData}
          errorMessage={mappingAlertErrorMsg}
          showMappingAlert={showMappingAlert}
          setShowMappingAlert={setShowMappingAlert}
        />
      }
      {mapSkuModal && <MapSkuModal
        open={mapSkuModal}
        onHide={() => setMapSkuModal(false)}
        rowIndex={rowIndex}
        expandRow={expandRow}
        onSave={handleRefreshPageData}
        handleShowMappingAlert={handleShowMappingAlert}
      />}
    </InventoryWrapper >
  );
};

export default Products;
